import { createAction } from '@reduxjs/toolkit';

export const SSO_LOGIN_ACTION_TYPE = 'saga/ssoLogin';
export const ssoLoginAction = createAction(SSO_LOGIN_ACTION_TYPE);
